import { useQuery } from '@tanstack/react-query';

import { getEditableRoadmap } from '../utils/editableRoadmap';

export const useEditableRoadmapById = (id: number | null, enabled = true) =>
  useQuery({
    queryKey: ['roadmap', 'editable', id],
    queryFn: async ({ signal }) => {
      if (id === null) throw new Error('Query disabled: id is null');
      return getEditableRoadmap(id, signal);
    },
    staleTime: 1000 * 60 * 5,
    enabled: enabled && id !== null,
  });
